import React, { useState, useEffect, useContext } from 'react'
import { AuthContext } from '../../Context'
import { AuthContextApi } from '../../Context/api'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { jsonConfig } from '../../Config'
import './index.css'
import {
    PencilIcon,
    XMarkIcon,
    BuildingOfficeIcon,
    UserIcon,
    PhoneIcon,
    EnvelopeIcon,
    IdentificationIcon,
    MapPinIcon,
    ArrowLeftIcon,
    ClockIcon,
    PlusIcon,
    MagnifyingGlassIcon,
    EyeIcon,
    TrashIcon,
    ChevronLeftIcon,
    ChevronRightIcon
} from '@heroicons/react/24/outline'

// Funções de formatação
const formatTelefone = (value) => {
    // Remove tudo que não é dígito
    const numbers = value.replace(/\D/g, '')

    // Limita a 11 dígitos (DDD + 9 dígitos)
    const limitedNumbers = numbers.slice(0, 11)

    // Aplica a máscara de telefone
    if (limitedNumbers.length <= 10) {
        return limitedNumbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
    } else {
        return limitedNumbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
    }
}

const formatCPFCNPJ = (value) => {
    // Remove tudo que não é dígito
    const numbers = value.replace(/\D/g, '')

    // Limita a 14 dígitos (máximo para CNPJ)
    const limitedNumbers = numbers.slice(0, 14)

    // Aplica a máscara baseada no tamanho
    if (limitedNumbers.length <= 11) {
        // CPF
        return limitedNumbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    } else {
        // CNPJ
        return limitedNumbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    }
}

const formatCEP = (value) => {
    // Remove tudo que não é dígito
    const numbers = value.replace(/\D/g, '')

    // Limita a 8 dígitos
    const limitedNumbers = numbers.slice(0, 8)

    // Aplica a máscara de CEP
    return limitedNumbers.replace(/(\d{5})(\d{3})/, '$1-$2')
}

const Proprietario = () => {
    const { states, setters } = useContext(AuthContext)
    const {
        getEntidades,
        putEntidades,
        getEntidadeHistorico,
        getLocalizacoes,
        getLocalizacaoHistorico,
        postLocalizacoes,
        putLocalizacoes,
        deleteLocalizacoes,
        getDepartamentos,
        getDepartamentoHistorico,
        postDepartamentos,
        putDepartamentos,
        deleteDepartamentos
    } = useContext(AuthContextApi)
    const navigate = useNavigate()

    // Função para retornar ao painel de entidades
    const navigateToEntidades = () => {
        navigate('/entidade')
    }

    // Estados locais
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [proprietarioData, setProprietarioData] = useState({})
    const [isSubmitting, setIsSubmitting] = useState(false)

    // Estados do formulário
    const [entidadeNome, setEntidadeNome] = useState('')
    const [entidadeEmail, setEntidadeEmail] = useState('')
    const [entidadeTelefone, setEntidadeTelefone] = useState('')
    const [entidadeCpfCnpj, setEntidadeCpfCnpj] = useState('')

    // Estados para histórico
    const [isHistoricoOpen, setIsHistoricoOpen] = useState(false)
    const [historicoPage, setHistoricoPage] = useState(0)
    const [historicoHasMore, setHistoricoHasMore] = useState(true)
    const [historicoLoading, setHistoricoLoading] = useState(false)

    // Estados para localizações
    const [isLocalizacaoModalOpen, setIsLocalizacaoModalOpen] = useState(false)
    const [localizacaoForm, setLocalizacaoForm] = useState({
        nome: '',
        numero: '',
        complemento: '',
        cep: ''
    })
    const [selectedLocalizacao, setSelectedLocalizacao] = useState(null)

    // Estados para departamentos
    const [isDepartamentoModalOpen, setIsDepartamentoModalOpen] = useState(false)
    const [departamentoForm, setDepartamentoForm] = useState({
        nome: '',
        localizacao_id: ''
    })
    const [selectedDepartamento, setSelectedDepartamento] = useState(null)
    const [selectedLocalizacaoForDepartamento, setSelectedLocalizacaoForDepartamento] = useState(null)

    // Estados para paginação
    const [localizacaoPage, setLocalizacaoPage] = useState(0)
    const [localizacaoTotalPages, setLocalizacaoTotalPages] = useState(0)
    const [localizacaoTotalItems, setLocalizacaoTotalItems] = useState(0)
    const [localizacaoLoading, setLocalizacaoLoading] = useState(false)

    const [departamentoPage, setDepartamentoPage] = useState(0)
    const [departamentoTotalPages, setDepartamentoTotalPages] = useState(0)
    const [departamentoTotalItems, setDepartamentoTotalItems] = useState(0)
    const [departamentoLoading, setDepartamentoLoading] = useState(false)

    // Estados para modais de histórico
    const [isLocalizacaoHistoricoOpen, setIsLocalizacaoHistoricoOpen] = useState(false)
    const [isDepartamentoHistoricoOpen, setIsDepartamentoHistoricoOpen] = useState(false)

    // Estados para modais de exclusão
    const [isDeleteLocalizacaoModalOpen, setIsDeleteLocalizacaoModalOpen] = useState(false)
    const [localizacaoToDelete, setLocalizacaoToDelete] = useState(null)
    const [isDeleteDepartamentoModalOpen, setIsDeleteDepartamentoModalOpen] = useState(false)
    const [departamentoToDelete, setDepartamentoToDelete] = useState(null)

    // Estados para paginação do histórico de localização
    const [localizacaoHistoricoPage, setLocalizacaoHistoricoPage] = useState(0)
    const [localizacaoHistoricoHasMore, setLocalizacaoHistoricoHasMore] = useState(true)
    const [localizacaoHistoricoLoading, setLocalizacaoHistoricoLoading] = useState(false)
    const [currentLocalizacaoId, setCurrentLocalizacaoId] = useState(null)

    // Estados para paginação do histórico de departamento
    const [departamentoHistoricoPage, setDepartamentoHistoricoPage] = useState(0)
    const [departamentoHistoricoHasMore, setDepartamentoHistoricoHasMore] = useState(true)
    const [departamentoHistoricoLoading, setDepartamentoHistoricoLoading] = useState(false)
    const [currentDepartamentoId, setCurrentDepartamentoId] = useState(null)

    // Função para carregar dados do proprietário (tipo 1)
    const loadProprietario = async () => {
        const query = new URLSearchParams({
            filter: 'tipo',
            search: '0' // Filtra apenas proprietário
        }).toString()

        await getEntidades(query)
    }

    // Função para carregar localizações
    const loadLocalizacoes = async (page = 0) => {
        if (proprietarioData && proprietarioData.id && !localizacaoLoading) {
            setLocalizacaoLoading(true)
            try {
                const query = new URLSearchParams({
                    entidade_id: proprietarioData.id,
                    page: page,
                    per_page: 10,
                    sort: 'data_criacao',
                    sort_dir: 'desc'
                }).toString()
                await getLocalizacoes(proprietarioData.id, query)

                // Atualiza informações de paginação
                setLocalizacaoPage(page)

                // Calcula total de páginas baseado no número de itens retornados
                const currentItems = states.dataLocalizacao?.length || 0
                if (currentItems < 10) {
                    // Se retornou menos que 10 itens, esta é a última página
                    setLocalizacaoTotalPages(page + 1)
                    setLocalizacaoTotalItems((page * 10) + currentItems)
                } else {
                    // Se retornou 10 itens, pode haver mais páginas
                    // Para uma implementação mais precisa, seria necessário um campo total do backend
                    setLocalizacaoTotalPages(page + 2) // Assumindo que há pelo menos mais uma página
                    setLocalizacaoTotalItems((page + 1) * 10)
                }
            } catch (error) {
                console.error('Erro ao carregar localizações:', error)
                toast.error('Erro ao carregar localizações')
            } finally {
                setLocalizacaoLoading(false)
            }
        }
    }

    // Função para próxima página de localizações
    const handleNextLocalizacoes = () => {
        loadLocalizacoes(localizacaoPage + 1)
    }

    // Função para página anterior de localizações
    const handlePreviousLocalizacoes = () => {
        if (localizacaoPage > 0 && !localizacaoLoading) {
            loadLocalizacoes(localizacaoPage - 1)
        }
    }

    // Função para carregar departamentos de uma localização
    const loadDepartamentos = async (localizacaoId, page = 0) => {
        if (localizacaoId && !departamentoLoading) {
            setDepartamentoLoading(true)
            try {
                const query = new URLSearchParams({
                    localizacao_id: localizacaoId,
                    page: page,
                    per_page: 10,
                    sort: 'data_criacao',
                    sort_dir: 'desc'
                }).toString()
                await getDepartamentos(localizacaoId, query)

                // Atualiza informações de paginação
                setDepartamentoPage(page)

                // Calcula total de páginas baseado no número de itens retornados
                const currentItems = states.dataDepartamento?.length || 0
                if (currentItems < 10) {
                    // Se retornou menos que 10 itens, esta é a última página
                    setDepartamentoTotalPages(page + 1)
                    setDepartamentoTotalItems((page * 10) + currentItems)
                } else {
                    // Se retornou 10 itens, pode haver mais páginas
                    // Para uma implementação mais precisa, seria necessário um campo total do backend
                    setDepartamentoTotalPages(page + 2) // Assumindo que há pelo menos mais uma página
                    setDepartamentoTotalItems((page + 1) * 10)
                }
            } catch (error) {
                console.error('Erro ao carregar departamentos:', error)
                toast.error('Erro ao carregar departamentos')
            } finally {
                setDepartamentoLoading(false)
            }
        }
    }

    // Função para próxima página de departamentos
    const handleNextDepartamentos = () => {
        if (selectedLocalizacaoForDepartamento) {
            loadDepartamentos(selectedLocalizacaoForDepartamento.id, departamentoPage + 1)
        }
    }

    // Função para página anterior de departamentos
    const handlePreviousDepartamentos = () => {
        if (departamentoPage > 0 && !departamentoLoading && selectedLocalizacaoForDepartamento) {
            loadDepartamentos(selectedLocalizacaoForDepartamento.id, departamentoPage - 1)
        }
    }

    // Função para abrir histórico da entidade
    const openHistoricoEntidade = async () => {
        if (proprietarioData && proprietarioData.id) {
            setHistoricoPage(0)
            setHistoricoHasMore(true)
            await loadHistoricoPage(0, true)
            setIsHistoricoOpen(true)
        }
    }

    // Função para carregar página do histórico
    const loadHistoricoPage = async (page, reset = false) => {
        if (proprietarioData && proprietarioData.id && !historicoLoading) {
            setHistoricoLoading(true)
            try {
                const query = new URLSearchParams({
                    page: page,
                    per_page: 10
                }).toString()

                const historico = await getEntidadeHistorico(proprietarioData.id, query)

                // Os dados do histórico são gerenciados pelo contexto

                // Verifica se há mais dados - se retornou menos que o solicitado, não há mais páginas
                // setHistoricoHasMore(historico.length === 10)
                setHistoricoPage(page)
            } catch (error) {
                console.error('Erro ao carregar histórico:', error)
                toast.error('Erro ao carregar histórico')
            } finally {
                setHistoricoLoading(false)
            }
        }
    }

    // Função para carregar mais dados do histórico
    const loadMoreHistorico = () => {
        if (historicoHasMore && !historicoLoading) {
            loadHistoricoPage(historicoPage + 1, false)
        }
    }

    // Função para fechar modal de histórico
    const closeHistoricoModal = () => {
        setIsHistoricoOpen(false)
        setHistoricoPage(0)
        setHistoricoHasMore(true)
        setHistoricoLoading(false)
    }


    // Função para abrir modal de edição
    const openEditModal = () => {
        if (proprietarioData && Object.keys(proprietarioData).length > 0) {
            setIsEditMode(true)
            setEntidadeNome(proprietarioData.nome || '')
            setEntidadeEmail(proprietarioData.email || '')
            setEntidadeTelefone(proprietarioData.telefone || '')
            setEntidadeCpfCnpj(proprietarioData.cpf_cnpj || '')
            setIsModalOpen(true)
        }
    }

    // Função para fechar modal
    const closeModal = () => {
        setIsModalOpen(false)
        setIsEditMode(false)
        setEntidadeNome('')
        setEntidadeEmail('')
        setEntidadeTelefone('')
        setEntidadeCpfCnpj('')
        setIsSubmitting(false)
    }

    // Função para salvar proprietário
    const handleSaveProprietario = async () => {
        if (!entidadeNome.trim()) {
            toast.error('Nome é obrigatório')
            return
        }

        if (!entidadeEmail.trim()) {
            toast.error('Email é obrigatório')
            return
        }

        if (!entidadeTelefone.trim()) {
            toast.error('Telefone é obrigatório')
            return
        }

        if (!entidadeCpfCnpj.trim()) {
            toast.error('CPF/CNPJ é obrigatório')
            return
        }

        setIsSubmitting(true)

        const proprietarioDataToSave = {
            nome: entidadeNome.trim(),
            tipo: 1, // Sempre proprietário
            email: entidadeEmail.trim(),
            telefone: entidadeTelefone.replace(/\D/g, ''), // Remove formatação
            cpf_cnpj: entidadeCpfCnpj.replace(/\D/g, ''), // Remove formatação
            id: proprietarioData.id
        }

        const success = await putEntidades(proprietarioDataToSave)
        if (success) {
            closeModal()
            setTimeout(() => {
                loadProprietario()
            }, 500)
        }

        setIsSubmitting(false)
    }

    // Função para salvar localização
    const handleSaveLocalizacao = async (e) => {
        e.preventDefault()

        if (!localizacaoForm.nome.trim()) {
            toast.error('Nome da localização é obrigatório')
            return
        }
        try {
            if (selectedLocalizacao) {
                // Editar localização existente
                await putLocalizacoes({
                    id: selectedLocalizacao.id,
                    nome: localizacaoForm.nome,
                    numero: parseInt(localizacaoForm.numero) || null,
                    complemento: localizacaoForm.complemento || null,
                    cep: localizacaoForm.cep.replace(/\D/g, '') // Remove formatação
                })
                toast.success('Localização atualizada com sucesso!')
            } else {
                // Criar nova localização
                await postLocalizacoes({
                    nome: localizacaoForm.nome,
                    numero: parseInt(localizacaoForm.numero) || null,
                    complemento: localizacaoForm.complemento || null,
                    cep: localizacaoForm.cep.replace(/\D/g, ''), // Remove formatação
                    entidade_id: proprietarioData.id
                })
                toast.success('Localização criada com sucesso!')
            }

            // Recarregar localizações
            await loadLocalizacoes()

            // Fechar modal e limpar formulário
            setIsLocalizacaoModalOpen(false)
            setSelectedLocalizacao(null)
            setLocalizacaoForm({ nome: '', numero: '', complemento: '', cep: '' })

        } catch (error) {
            console.error('Erro ao salvar localização:', error)
            toast.error('Erro ao salvar localização')
        }
    }

    // Função para salvar departamento
    const handleSaveDepartamento = async (e) => {
        e.preventDefault()

        if (!departamentoForm.nome.trim()) {
            toast.error('Nome do departamento é obrigatório')
            return
        }

        try {
            if (selectedDepartamento) {
                // Editar departamento existente - não precisa enviar localizacao_id
                await putDepartamentos({
                    id: selectedDepartamento.id,
                    nome: departamentoForm.nome,
                    localizacao_id: selectedLocalizacaoForDepartamento.id
                })
                toast.success('Departamento atualizado com sucesso!')
            } else {
                // Criar novo departamento
                await postDepartamentos({
                    nome: departamentoForm.nome,
                    localizacao_id: selectedLocalizacaoForDepartamento.id
                })
                toast.success('Departamento criado com sucesso!')
            }

            // Recarregar departamentos
            await loadDepartamentos(selectedLocalizacaoForDepartamento.id)

            // Fechar modal e limpar formulário
            setIsDepartamentoModalOpen(false)
            setSelectedDepartamento(null)
            setDepartamentoForm({ nome: '', localizacao_id: '' })

        } catch (error) {
            console.error('Erro ao salvar departamento:', error)
            toast.error('Erro ao salvar departamento')
        }
    }

    // Função para abrir modal de edição de localização
    const openEditLocalizacaoModal = (localizacao) => {
        setSelectedLocalizacao(localizacao)
        setLocalizacaoForm({
            nome: localizacao.nome || '',
            numero: localizacao.numero || '',
            complemento: localizacao.complemento || '',
            cep: localizacao.cep || ''
        })
        setIsLocalizacaoModalOpen(true)
    }

    // Função para abrir modal de edição de departamento
    const openEditDepartamentoModal = (departamento) => {
        setSelectedDepartamento(departamento)
        setDepartamentoForm({
            nome: departamento.nome || '',
            localizacao_id: departamento.localizacao_id || ''
        })
        setIsDepartamentoModalOpen(true)
    }

    // Função para abrir histórico de localização
    const openHistoricoLocalizacao = async (localizacaoId) => {
        setCurrentLocalizacaoId(localizacaoId)
        setLocalizacaoHistoricoPage(0)
        setLocalizacaoHistoricoHasMore(true)
        await loadLocalizacaoHistoricoPage(localizacaoId, 0, true)
        setIsLocalizacaoHistoricoOpen(true)
    }

    // Função para carregar página do histórico de localização
    const loadLocalizacaoHistoricoPage = async (localizacaoId, page, reset = false) => {
        if (!localizacaoHistoricoLoading) {
            setLocalizacaoHistoricoLoading(true)
            try {
                const query = new URLSearchParams({
                    page: page,
                    per_page: 10
                }).toString()

                await getLocalizacaoHistorico(localizacaoId, query)

                // Verifica se há mais dados baseado no tamanho da resposta
                const currentData = states.localizacaoHistorico || []
                // setLocalizacaoHistoricoHasMore(currentData.length === 10)
                setLocalizacaoHistoricoPage(page)
            } catch (error) {
                console.error('Erro ao carregar histórico da localização:', error)
                toast.error('Erro ao carregar histórico da localização')
            } finally {
                setLocalizacaoHistoricoLoading(false)
            }
        }
    }

    // Função para carregar mais histórico de localização
    const loadMoreLocalizacaoHistorico = () => {
        if (localizacaoHistoricoHasMore && !localizacaoHistoricoLoading && currentLocalizacaoId) {
            loadLocalizacaoHistoricoPage(currentLocalizacaoId, localizacaoHistoricoPage + 1, false)
        }
    }

    // Função para fechar modal de histórico de localização
    const closeLocalizacaoHistoricoModal = () => {
        setIsLocalizacaoHistoricoOpen(false)
        setCurrentLocalizacaoId(null)
        setLocalizacaoHistoricoPage(0)
        setLocalizacaoHistoricoHasMore(true)
        setLocalizacaoHistoricoLoading(false)
    }

    // Função para abrir histórico de departamento
    const openHistoricoDepartamento = async (departamentoId) => {
        setCurrentDepartamentoId(departamentoId)
        setDepartamentoHistoricoPage(0)
        setDepartamentoHistoricoHasMore(true)
        await loadDepartamentoHistoricoPage(departamentoId, 0, true)
        setIsDepartamentoHistoricoOpen(true)
    }

    // Função para carregar página do histórico de departamento
    const loadDepartamentoHistoricoPage = async (departamentoId, page, reset = false) => {
        if (!departamentoHistoricoLoading) {
            setDepartamentoHistoricoLoading(true)
            try {
                const query = new URLSearchParams({
                    page: page,
                    per_page: 10
                }).toString()

                await getDepartamentoHistorico(departamentoId, query)

                // Verifica se há mais dados baseado no tamanho da resposta
                const currentData = states.departamentoHistorico || []
                setDepartamentoHistoricoHasMore(currentData.length === 10)
                setDepartamentoHistoricoPage(page)
            } catch (error) {
                console.error('Erro ao carregar histórico do departamento:', error)
                toast.error('Erro ao carregar histórico do departamento')
            } finally {
                setDepartamentoHistoricoLoading(false)
            }
        }
    }

    // Função para carregar mais histórico de departamento
    const loadMoreDepartamentoHistorico = () => {
        if (departamentoHistoricoHasMore && !departamentoHistoricoLoading && currentDepartamentoId) {
            loadDepartamentoHistoricoPage(currentDepartamentoId, departamentoHistoricoPage + 1, false)
        }
    }

    // Função para fechar modal de histórico de departamento
    const closeDepartamentoHistoricoModal = () => {
        setIsDepartamentoHistoricoOpen(false)
        setCurrentDepartamentoId(null)
        setDepartamentoHistoricoPage(0)
        setDepartamentoHistoricoHasMore(true)
        setDepartamentoHistoricoLoading(false)
    }

    // Funções para verificar se pode deletar
    const canDeleteLocalizacao = (localizacao) => {
        const userEmail = localStorage.getItem('usuario')
        return localizacao.canDelete === true && userEmail === jsonConfig.userMaster
    }

    const canDeleteDepartamento = (departamento) => {
        const userEmail = localStorage.getItem('usuario')
        return departamento.canDelete === true && userEmail === jsonConfig.userMaster
    }

    // Função para abrir modal de confirmação de exclusão de localização
    const openDeleteLocalizacaoModal = (localizacao) => {
        setLocalizacaoToDelete(localizacao)
        setIsDeleteLocalizacaoModalOpen(true)
    }

    // Função para fechar modal de confirmação de exclusão de localização
    const closeDeleteLocalizacaoModal = () => {
        setIsDeleteLocalizacaoModalOpen(false)
        setLocalizacaoToDelete(null)
    }

    // Função para confirmar exclusão de localização
    const handleConfirmDeleteLocalizacao = async () => {
        if (!localizacaoToDelete) return

        setIsSubmitting(true)
        const success = await deleteLocalizacoes(localizacaoToDelete.id)

        if (success) {
            closeDeleteLocalizacaoModal()
            // Recarrega as localizações imediatamente após exclusão
            await loadLocalizacoes()
        }

        setIsSubmitting(false)
    }

    // Função para abrir modal de confirmação de exclusão de departamento
    const openDeleteDepartamentoModal = (departamento) => {
        setDepartamentoToDelete(departamento)
        setIsDeleteDepartamentoModalOpen(true)
    }

    // Função para fechar modal de confirmação de exclusão de departamento
    const closeDeleteDepartamentoModal = () => {
        setIsDeleteDepartamentoModalOpen(false)
        setDepartamentoToDelete(null)
    }

    // Função para confirmar exclusão de departamento
    const handleConfirmDeleteDepartamento = async () => {
        if (!departamentoToDelete) return

        setIsSubmitting(true)
        const success = await deleteDepartamentos(departamentoToDelete.id)

        if (success) {
            closeDeleteDepartamentoModal()
            // Recarrega os departamentos imediatamente após exclusão
            await loadDepartamentos(selectedLocalizacaoForDepartamento.id)
        }

        setIsSubmitting(false)
    }

    // useEffect para carregar dados do proprietário
    useEffect(() => {
        loadProprietario()
        return () => {
            setters.setIsLoading(false)
            setters.setDataEntidades([])
        }
    }, [])

    // useEffect para atualizar dados do proprietário quando carregados
    useEffect(() => {
        if (states.dataEntidades && Array.isArray(states.dataEntidades) && states.dataEntidades.length > 0) {
            setProprietarioData(states.dataEntidades[0])
        }
    }, [states.dataEntidades])

    // useEffect para carregar localizações quando proprietário for carregado
    useEffect(() => {
        if (proprietarioData && Object.keys(proprietarioData).length > 0) {
            loadLocalizacoes()
        }
    }, [proprietarioData])



    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50/30">

            {/* Conteúdo Principal */}
            <div className="max-w-full mx-auto px-2 sm:px-4 lg:px-6 py-6">
                {/* Painel Principal - Ocupa Tela Toda */}
                {proprietarioData && Object.keys(proprietarioData).length > 0 ? (
                    <div className="relative bg-gradient-to-br from-blue-50/80 via-white/80 to-blue-50/80 backdrop-blur-sm rounded-3xl shadow-xl border border-blue-100/50 overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-blue-500/5"></div>
                        <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-blue-400/10 to-blue-400/10 rounded-full -translate-y-20 translate-x-20"></div>
                        <div className="absolute bottom-0 left-0 w-32 h-32 bg-gradient-to-br from-blue-300/10 to-blue-300/10 rounded-full translate-y-16 -translate-x-16"></div>

                        {/* Header Principal */}
                        <div className="relative p-4 sm:p-6 border-b border-blue-100/50">
                            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
                                <div className="flex items-center">
                                    <div className="p-2 sm:p-3 rounded-xl sm:rounded-2xl bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 shadow-lg mr-3 sm:mr-4">
                                        <BuildingOfficeIcon className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                                    </div>
                                    <div className="min-w-0 flex-1">
                                        <h2 className="text-lg sm:text-2xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-blue-700 bg-clip-text text-transparent truncate">
                                            {proprietarioData.nome}
                                        </h2>
                                        <p className="text-xs sm:text-sm text-gray-600 mt-1">
                                            Dados do Proprietário do Sistema
                                        </p>
                                    </div>
                                </div>
                                <div className="flex items-center justify-between sm:justify-end space-x-2 sm:space-x-3">
                                    <span className="inline-flex items-center px-2 sm:px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200">
                                        Proprietário
                                    </span>
                                    <div className="flex items-center space-x-2">
                                        <button
                                            onClick={openHistoricoEntidade}
                                            className="group relative inline-flex items-center px-2 sm:px-3 py-2 border border-gray-300 rounded-lg sm:rounded-xl text-xs sm:text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300"
                                        >
                                            <ClockIcon className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2 group-hover:scale-110 transition-transform duration-200" />
                                            <span className="hidden sm:inline">Histórico</span>
                                        </button>
                                        <button
                                            onClick={openEditModal}
                                            className="group relative inline-flex items-center px-3 sm:px-4 py-2 border border-transparent rounded-lg sm:rounded-xl shadow-lg text-xs sm:text-sm font-semibold text-white bg-gradient-to-r from-blue-600 via-blue-700 to-blue-700 hover:from-blue-700 hover:via-blue-800 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 transform hover:scale-105"
                                        >
                                            <div className="relative z-10 flex items-center">
                                                <PencilIcon className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2 group-hover:scale-110 transition-transform duration-200" />
                                                <span className="hidden sm:inline">Editar</span>
                                                <span className="sm:hidden">Edit</span>
                                            </div>
                                            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-blue-500/10 rounded-lg sm:rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Informações Principais */}
                        <div className="relative p-4 sm:p-6">
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
                                {/* Email */}
                                {proprietarioData.email && (
                                    <div className="flex items-center p-3 sm:p-4 bg-white/60 backdrop-blur-sm rounded-lg sm:rounded-xl border border-blue-100/50 hover:shadow-lg transition-all duration-300">
                                        <EnvelopeIcon className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 mr-2 sm:mr-3 flex-shrink-0" />
                                        <div className="min-w-0 flex-1">
                                            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Email</p>
                                            <p className="text-xs sm:text-sm font-semibold text-gray-900 truncate">{proprietarioData.email}</p>
                                        </div>
                                    </div>
                                )}

                                {/* Telefone */}
                                {proprietarioData.telefone && (
                                    <div className="flex items-center p-3 sm:p-4 bg-white/60 backdrop-blur-sm rounded-lg sm:rounded-xl border border-blue-100/50 hover:shadow-lg transition-all duration-300">
                                        <PhoneIcon className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 mr-2 sm:mr-3 flex-shrink-0" />
                                        <div className="min-w-0 flex-1">
                                            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Telefone</p>
                                            <p className="text-xs sm:text-sm font-semibold text-gray-900">{formatTelefone(proprietarioData.telefone)}</p>
                                        </div>
                                    </div>
                                )}

                                {/* CPF/CNPJ */}
                                {proprietarioData.cpf_cnpj && (
                                    <div className="flex items-center p-3 sm:p-4 bg-white/60 backdrop-blur-sm rounded-lg sm:rounded-xl border border-blue-100/50 hover:shadow-lg transition-all duration-300">
                                        <IdentificationIcon className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 mr-2 sm:mr-3 flex-shrink-0" />
                                        <div className="min-w-0 flex-1">
                                            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">CPF/CNPJ</p>
                                            <p className="text-xs sm:text-sm font-semibold text-gray-900">{formatCPFCNPJ(proprietarioData.cpf_cnpj)}</p>
                                        </div>
                                    </div>
                                )}

                                {/* Endereço */}
                                {(proprietarioData.logradouro || proprietarioData.bairro || proprietarioData.cidade || proprietarioData.estado) && (
                                    <div className="flex items-center p-3 sm:p-4 bg-white/60 backdrop-blur-sm rounded-lg sm:rounded-xl border border-blue-100/50 hover:shadow-lg transition-all duration-300">
                                        <MapPinIcon className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 mr-2 sm:mr-3 flex-shrink-0" />
                                        <div className="min-w-0 flex-1">
                                            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Endereço</p>
                                            <p className="text-xs sm:text-sm font-semibold text-gray-900 truncate">
                                                {proprietarioData.logradouro && `${proprietarioData.logradouro}`}
                                                {proprietarioData.numero && `, ${proprietarioData.numero}`}
                                                {proprietarioData.bairro && ` - ${proprietarioData.bairro}`}
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {/* Data de Atualização */}
                                <div className="flex items-center p-3 sm:p-4 bg-white/60 backdrop-blur-sm rounded-lg sm:rounded-xl border border-blue-100/50 hover:shadow-lg transition-all duration-300">
                                    <div className="w-4 h-4 sm:w-5 sm:h-5 bg-blue-600 rounded-full mr-2 sm:mr-3 flex items-center justify-center flex-shrink-0">
                                        <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full"></div>
                                    </div>
                                    <div className="min-w-0 flex-1">
                                        <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Atualizado</p>
                                        <p className="text-xs sm:text-sm font-semibold text-gray-900">{new Date(proprietarioData.data_atualizacao).toLocaleDateString('pt-BR')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="text-center py-16 bg-white/60 rounded-3xl border border-blue-100/50">
                        <BuildingOfficeIcon className="w-16 h-16 text-gray-400 mx-auto mb-6" />
                        <h3 className="text-xl font-medium text-gray-900 mb-3">Carregando dados do proprietário...</h3>
                        <p className="text-gray-500">Aguarde enquanto os dados são carregados do servidor.</p>
                    </div>
                )}

                {/* Seção de Localizações */}
                {proprietarioData && Object.keys(proprietarioData).length > 0 && (
                    <div className="mt-8">
                        <div className="relative bg-gradient-to-br from-blue-50/80 via-white/80 to-blue-50/80 backdrop-blur-sm rounded-2xl shadow-lg border border-blue-100/50 overflow-hidden">
                            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-blue-500/5"></div>

                            {/* Header da Seção */}
                            <div className="relative p-4 sm:p-6 border-b border-blue-100/50">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <div className="p-2 sm:p-3 rounded-xl bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 shadow-lg mr-3 sm:mr-4">
                                            <MapPinIcon className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
                                        </div>
                                        <div>
                                            <h3 className="text-lg sm:text-xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-blue-700 bg-clip-text text-transparent">
                                                Localizações
                                            </h3>
                                            <p className="text-xs sm:text-sm text-gray-600">
                                                Gerencie as localizações do proprietário
                                            </p>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => setIsLocalizacaoModalOpen(true)}
                                        className="group relative inline-flex items-center px-3 sm:px-4 py-2 border border-transparent rounded-lg sm:rounded-xl shadow-lg text-xs sm:text-sm font-semibold text-white bg-gradient-to-r from-blue-600 via-blue-700 to-blue-700 hover:from-blue-700 hover:via-blue-800 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 transform hover:scale-105"
                                    >
                                        <PlusIcon className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2 group-hover:scale-110 transition-transform duration-200" />
                                        <span className="hidden sm:inline">Nova Localização</span>
                                        <span className="sm:hidden">Nova</span>
                                    </button>
                                </div>
                            </div>

                            {/* Lista de Localizações */}
                            <div className="relative p-4 sm:p-6">
                                {states.dataLocalizacao && states.dataLocalizacao.length > 0 ? (
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                        {states.dataLocalizacao.map((localizacao) => (
                                            <div key={localizacao.id} className="bg-white/60 backdrop-blur-sm rounded-xl border border-blue-100/50 p-4 hover:shadow-lg transition-all duration-300">
                                                <div className="flex items-center mb-3">
                                                    <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                                                        <MapPinIcon className="w-4 h-4 text-blue-600" />
                                                    </div>
                                                    <div className="min-w-0 flex-1">
                                                        <h4 className="text-sm font-semibold text-gray-900 truncate">
                                                            {localizacao.nome}
                                                        </h4>
                                                        <p className="text-xs text-gray-500">
                                                            {localizacao.logradouro && `${localizacao.logradouro}`}
                                                            {localizacao.numero && `, ${localizacao.numero}`}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex items-center justify-end space-x-1 mb-3">
                                                    <button
                                                        onClick={() => openEditLocalizacaoModal(localizacao)}
                                                        className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                                                        title="Editar Localização"
                                                    >
                                                        <PencilIcon className="w-3 h-3 text-gray-600" />
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            setSelectedLocalizacaoForDepartamento(localizacao)
                                                            loadDepartamentos(localizacao.id)
                                                        }}
                                                        className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                                                        title="Ver Departamentos"
                                                    >
                                                        <EyeIcon className="w-3 h-3 text-gray-600" />
                                                    </button>
                                                    <button
                                                        onClick={() => openHistoricoLocalizacao(localizacao.id)}
                                                        className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                                                        title="Ver Histórico"
                                                    >
                                                        <ClockIcon className="w-3 h-3 text-gray-600" />
                                                    </button>
                                                    {canDeleteLocalizacao(localizacao) && (
                                                        <button
                                                            onClick={() => openDeleteLocalizacaoModal(localizacao)}
                                                            className="p-1.5 rounded-lg hover:bg-red-100 transition-colors duration-200"
                                                            title="Excluir Localização"
                                                        >
                                                            <TrashIcon className="w-3 h-3 text-red-600" />
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="space-y-1">
                                                    {localizacao.bairro && (
                                                        <p className="text-xs text-gray-600">{localizacao.bairro}</p>
                                                    )}
                                                    {localizacao.cidade && localizacao.estado && (
                                                        <p className="text-xs text-gray-600">
                                                            {localizacao.cidade}, {localizacao.estado}
                                                        </p>
                                                    )}
                                                    {localizacao.cep && (
                                                        <p className="text-xs text-gray-500">CEP: {formatCEP(localizacao.cep)}</p>
                                                    )}
                                                </div>
                                            </div>
                                        ))}

                                        {/* Paginação de Localizações */}
                                        {states.dataLocalizacao && states.dataLocalizacao.length > 0 && (
                                            <div className="col-span-full flex items-center justify-between bg-white rounded-2xl shadow-lg border border-gray-200 p-4 mt-6">
                                                <div className="flex space-x-2">
                                                    <button
                                                        onClick={handlePreviousLocalizacoes}
                                                        disabled={localizacaoPage === 0}
                                                        className="px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                                                    >
                                                        <ChevronLeftIcon className="w-4 h-4" />
                                                    </button>
                                                    <span className="px-3 py-2 text-sm font-medium text-gray-700">
                                                        Página {localizacaoPage + 1} de {localizacaoTotalPages}
                                                    </span>
                                                    <button
                                                        onClick={handleNextLocalizacoes}
                                                        className="px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                                                    >
                                                        <ChevronRightIcon className="w-4 h-4" />
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="text-center py-8">
                                        <MapPinIcon className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                                        <h4 className="text-sm font-medium text-gray-900 mb-2">Nenhuma localização encontrada</h4>
                                        <p className="text-xs text-gray-500 mb-4">Comece adicionando uma nova localização</p>
                                        <button
                                            onClick={() => setIsLocalizacaoModalOpen(true)}
                                            className="inline-flex items-center px-3 py-2 border border-transparent rounded-lg shadow-sm text-xs font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                        >
                                            <PlusIcon className="w-3 h-3 mr-1" />
                                            Adicionar Localização
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* Seção de Departamentos */}
                {selectedLocalizacaoForDepartamento && (
                    <div className="mt-6">
                        <div className="relative bg-gradient-to-br from-gray-50/80 via-white/80 to-gray-50/80 backdrop-blur-sm rounded-2xl shadow-lg border border-gray-100/50 overflow-hidden">
                            <div className="absolute inset-0 bg-gradient-to-br from-gray-500/5 to-gray-500/5"></div>

                            {/* Header da Seção */}
                            <div className="relative p-4 sm:p-6 border-b border-gray-100/50">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <div className="p-2 sm:p-3 rounded-xl bg-gradient-to-r from-gray-500 via-gray-600 to-gray-700 shadow-lg mr-3 sm:mr-4">
                                            <BuildingOfficeIcon className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
                                        </div>
                                        <div>
                                            <h3 className="text-lg sm:text-xl font-bold bg-gradient-to-r from-gray-900 via-gray-800 to-gray-700 bg-clip-text text-transparent">
                                                Departamentos - {selectedLocalizacaoForDepartamento.nome}
                                            </h3>
                                            <p className="text-xs sm:text-sm text-gray-600">
                                                Gerencie os departamentos desta localização
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <button
                                            onClick={() => {
                                                setSelectedLocalizacaoForDepartamento(null)
                                            }}
                                            className="px-3 py-2 border border-gray-300 rounded-lg text-xs sm:text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200"
                                        >
                                            Voltar
                                        </button>
                                        <button
                                            onClick={() => {
                                                setDepartamentoForm({
                                                    nome: '',
                                                    localizacao_id: selectedLocalizacaoForDepartamento.id
                                                })
                                                setIsDepartamentoModalOpen(true)
                                            }}
                                            className="group relative inline-flex items-center px-3 sm:px-4 py-2 border border-transparent rounded-lg sm:rounded-xl shadow-lg text-xs sm:text-sm font-semibold text-white bg-gradient-to-r from-gray-600 via-gray-700 to-gray-700 hover:from-gray-700 hover:via-gray-800 hover:to-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all duration-300 transform hover:scale-105"
                                        >
                                            <PlusIcon className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2 group-hover:scale-110 transition-transform duration-200" />
                                            <span className="hidden sm:inline">Novo Departamento</span>
                                            <span className="sm:hidden">Novo</span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Lista de Departamentos */}
                            <div className="relative p-4 sm:p-6">
                                {states.dataDepartamento && states.dataDepartamento.length > 0 ? (
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                        {states.dataDepartamento.map((departamento) => (
                                            <div key={departamento.id} className="bg-white/60 backdrop-blur-sm rounded-xl border border-gray-100/50 p-4 hover:shadow-lg transition-all duration-300">
                                                <div className="flex items-center mb-3">
                                                    <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center mr-3">
                                                        <BuildingOfficeIcon className="w-4 h-4 text-gray-600" />
                                                    </div>
                                                    <div className="min-w-0 flex-1">
                                                        <h4 className="text-sm font-semibold text-gray-900 truncate">
                                                            {departamento.nome}
                                                        </h4>
                                                        <p className="text-xs text-gray-500">
                                                            Departamento
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex items-center justify-end space-x-1 mb-3">
                                                    <button
                                                        onClick={() => openEditDepartamentoModal(departamento)}
                                                        className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                                                        title="Editar Departamento"
                                                    >
                                                        <PencilIcon className="w-3 h-3 text-gray-600" />
                                                    </button>
                                                    <button
                                                        onClick={() => openHistoricoDepartamento(departamento.id)}
                                                        className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                                                        title="Ver Histórico"
                                                    >
                                                        <ClockIcon className="w-3 h-3 text-gray-600" />
                                                    </button>
                                                    {canDeleteDepartamento(departamento) && (
                                                        <button
                                                            onClick={() => openDeleteDepartamentoModal(departamento)}
                                                            className="p-1.5 rounded-lg hover:bg-red-100 transition-colors duration-200"
                                                            title="Excluir Departamento"
                                                        >
                                                            <TrashIcon className="w-3 h-3 text-red-600" />
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="space-y-1">
                                                    <p className="text-xs text-gray-500">
                                                        Criado: {new Date(departamento.data_criacao).toLocaleDateString('pt-BR')}
                                                    </p>
                                                    <p className="text-xs text-gray-500">
                                                        Atualizado: {new Date(departamento.data_atualizacao).toLocaleDateString('pt-BR')}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}

                                        {/* Paginação de Departamentos */}
                                        {states.dataDepartamento && states.dataDepartamento.length > 0 && (
                                            <div className="col-span-full flex items-center justify-between bg-white rounded-2xl shadow-lg border border-gray-200 p-4 mt-6">
                                                <div className="flex space-x-2">
                                                    <button
                                                        onClick={handlePreviousDepartamentos}
                                                        disabled={departamentoPage === 0}
                                                        className="px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                                                    >
                                                        <ChevronLeftIcon className="w-4 h-4" />
                                                    </button>
                                                    <span className="px-3 py-2 text-sm font-medium text-gray-700">
                                                        Página {departamentoPage + 1} de {departamentoTotalPages}
                                                    </span>
                                                    <button
                                                        onClick={handleNextDepartamentos}
                                                        className="px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                                                    >
                                                        <ChevronRightIcon className="w-4 h-4" />
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="text-center py-8">
                                        <BuildingOfficeIcon className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                                        <h4 className="text-sm font-medium text-gray-900 mb-2">Nenhum departamento encontrado</h4>
                                        <p className="text-xs text-gray-500 mb-4">Comece adicionando um novo departamento</p>
                                        <button
                                            onClick={() => {
                                                setDepartamentoForm({
                                                    nome: '',
                                                    localizacao_id: selectedLocalizacaoForDepartamento.id
                                                })
                                                setIsDepartamentoModalOpen(true)
                                            }}
                                            className="inline-flex items-center px-3 py-2 border border-transparent rounded-lg shadow-sm text-xs font-medium text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                        >
                                            <PlusIcon className="w-3 h-3 mr-1" />
                                            Adicionar Departamento
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Modal de Editar Proprietário - Design Google */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-50">
                    <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden">
                        {/* Header Minimalista */}
                        <div className="px-6 py-4 border-b border-gray-100">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                                        <BuildingOfficeIcon className="w-5 h-5 text-blue-600" />
                                    </div>
                                    <div>
                                        <h2 className="text-lg font-semibold text-gray-900">
                                            Editar Proprietário
                                        </h2>
                                        <p className="text-sm text-gray-500">
                                            Atualize as informações
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={closeModal}
                                    className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-5 h-5 text-gray-500" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Modal */}
                        <div className="px-6 py-6 space-y-5">
                            {/* Nome */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700">
                                    Nome do Proprietário *
                                </label>
                                <input
                                    type="text"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSaveProprietario()
                                        }
                                    }}
                                    value={entidadeNome}
                                    onChange={(e) => setEntidadeNome(e.target.value)}
                                    placeholder="Digite o nome do proprietário"
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-sm"
                                />
                            </div>

                            {/* Email */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700">
                                    Email *
                                </label>
                                <input
                                    type="email"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSaveProprietario()
                                        }
                                    }}
                                    value={entidadeEmail}
                                    onChange={(e) => setEntidadeEmail(e.target.value)}
                                    placeholder="Digite o email"
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-sm"
                                />
                            </div>

                            {/* Telefone */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700">
                                    Telefone *
                                </label>
                                <input
                                    type="tel"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSaveProprietario()
                                        }
                                    }}
                                    value={formatTelefone(entidadeTelefone)}
                                    onChange={(e) => setEntidadeTelefone(e.target.value)}
                                    placeholder="(11) 99999-9999"
                                    maxLength={15}
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-sm"
                                />
                            </div>

                            {/* CPF/CNPJ */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700">
                                    CPF/CNPJ *
                                </label>
                                <input
                                    type="text"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSaveProprietario()
                                        }
                                    }}
                                    value={formatCPFCNPJ(entidadeCpfCnpj)}
                                    onChange={(e) => setEntidadeCpfCnpj(e.target.value)}
                                    placeholder="000.000.000-00 ou 00.000.000/0000-00"
                                    maxLength={18}
                                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-sm"
                                />
                            </div>
                        </div>

                        {/* Footer Minimalista */}
                        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end space-x-3">
                            <button
                                onClick={closeModal}
                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleSaveProprietario}
                                disabled={isSubmitting}
                                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 flex items-center"
                            >
                                {isSubmitting ? (
                                    <>
                                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                        Salvando...
                                    </>
                                ) : (
                                    'Salvar alterações'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Histórico da Entidade */}
            {isHistoricoOpen && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-50">
                    <div className="relative bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
                        {/* Header do Modal */}
                        <div className="px-6 py-4 border-b border-gray-100">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                                        <ClockIcon className="w-5 h-5 text-blue-600" />
                                    </div>
                                    <div>
                                        <h2 className="text-lg font-semibold text-gray-900">
                                            Histórico da Entidade
                                        </h2>
                                        <p className="text-sm text-gray-500">
                                            {proprietarioData.nome}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={closeHistoricoModal}
                                    className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-5 h-5 text-gray-500" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Histórico */}
                        <div className="px-6 py-6 max-h-[70vh] overflow-y-auto">
                            {states.entidadeHistorico && states.entidadeHistorico.length > 0 ? (
                                <div className="space-y-4">
                                    {states.entidadeHistorico.map((item, index) => (
                                        <div key={item.id} className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                                            {/* Header do Item */}
                                            <div className="flex items-center justify-between mb-3">
                                                <div className="flex items-center">
                                                    <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${item.transformacao === 'Criação' ? 'bg-green-100' :
                                                        item.transformacao === 'Atualização' ? 'bg-blue-100' :
                                                            'bg-gray-100'
                                                        }`}>
                                                        {item.transformacao === 'Criação' ? (
                                                            <PlusIcon className="w-4 h-4 text-green-600" />
                                                        ) : item.transformacao === 'Atualização' ? (
                                                            <PencilIcon className="w-4 h-4 text-blue-600" />
                                                        ) : (
                                                            <TrashIcon className="w-4 h-4 text-gray-600" />
                                                        )}
                                                    </div>
                                                    <div>
                                                        <h3 className="text-sm font-semibold text-gray-900">
                                                            {item.transformacao}
                                                        </h3>
                                                        <p className="text-xs text-gray-500">
                                                            por {item.user_email}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="text-right">
                                                    <p className="text-xs text-gray-500">
                                                        {new Date(item.data_atualizacao).toLocaleDateString('pt-BR')}
                                                    </p>
                                                    <p className="text-xs text-gray-400">
                                                        {new Date(item.data_atualizacao).toLocaleTimeString('pt-BR')}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* Dados Atuais */}
                                            {item.dado_atual && (
                                                <div className="mb-3">
                                                    <h4 className="text-xs font-medium text-gray-700 uppercase tracking-wide mb-2">
                                                        Dados Atuais
                                                    </h4>
                                                    <div className="bg-white rounded-lg p-3 border border-gray-100">
                                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                            {item.dado_atual.nome && (
                                                                <div>
                                                                    <p className="text-xs font-medium text-gray-500">Nome</p>
                                                                    <p className="text-sm font-semibold text-gray-900">{item.dado_atual.nome}</p>
                                                                </div>
                                                            )}
                                                            {item.dado_atual.email && (
                                                                <div>
                                                                    <p className="text-xs font-medium text-gray-500">Email</p>
                                                                    <p className="text-sm font-semibold text-gray-900">{item.dado_atual.email}</p>
                                                                </div>
                                                            )}
                                                            {item.dado_atual.telefone && (
                                                                <div>
                                                                    <p className="text-xs font-medium text-gray-500">Telefone</p>
                                                                    <p className="text-sm font-semibold text-gray-900">{formatTelefone(item.dado_atual.telefone)}</p>
                                                                </div>
                                                            )}
                                                            {item.dado_atual.cpf_cnpj && (
                                                                <div>
                                                                    <p className="text-xs font-medium text-gray-500">CPF/CNPJ</p>
                                                                    <p className="text-sm font-semibold text-gray-900">{formatCPFCNPJ(item.dado_atual.cpf_cnpj)}</p>
                                                                </div>
                                                            )}
                                                            {item.dado_atual.tipo !== undefined && (
                                                                <div>
                                                                    <p className="text-xs font-medium text-gray-500">Tipo</p>
                                                                    <p className="text-sm font-semibold text-gray-900">
                                                                        {item.dado_atual.tipo === 0 ? 'Fornecedor' :
                                                                            item.dado_atual.tipo === 1 ? 'Proprietário' :
                                                                                'Cliente'}
                                                                    </p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Dados Antigos (se houver) */}
                                            {item.dado_antigo && (
                                                <div>
                                                    <h4 className="text-xs font-medium text-gray-700 uppercase tracking-wide mb-2">
                                                        Dados Anteriores
                                                    </h4>
                                                    <div className="bg-red-50 rounded-lg p-3 border border-red-100">
                                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                            {item.dado_antigo.nome && (
                                                                <div>
                                                                    <p className="text-xs font-medium text-gray-500">Nome</p>
                                                                    <p className="text-sm font-semibold text-gray-900">{item.dado_antigo.nome}</p>
                                                                </div>
                                                            )}
                                                            {item.dado_antigo.email && (
                                                                <div>
                                                                    <p className="text-xs font-medium text-gray-500">Email</p>
                                                                    <p className="text-sm font-semibold text-gray-900">{item.dado_antigo.email}</p>
                                                                </div>
                                                            )}
                                                            {item.dado_antigo.telefone && (
                                                                <div>
                                                                    <p className="text-xs font-medium text-gray-500">Telefone</p>
                                                                    <p className="text-sm font-semibold text-gray-900">{formatTelefone(item.dado_antigo.telefone)}</p>
                                                                </div>
                                                            )}
                                                            {item.dado_antigo.cpf_cnpj && (
                                                                <div>
                                                                    <p className="text-xs font-medium text-gray-500">CPF/CNPJ</p>
                                                                    <p className="text-sm font-semibold text-gray-900">{formatCPFCNPJ(item.dado_antigo.cpf_cnpj)}</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}

                                    {/* Botão Carregar Mais */}
                                    {historicoHasMore && (
                                        <div className="flex justify-center mt-6">
                                            <button
                                                onClick={loadMoreHistorico}
                                                disabled={historicoLoading}
                                                className="group relative inline-flex items-center px-6 py-3 border border-transparent rounded-xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-blue-600 via-blue-700 to-blue-700 hover:from-blue-700 hover:via-blue-800 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                {historicoLoading ? (
                                                    <>
                                                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                                        Carregando...
                                                    </>
                                                ) : (
                                                    <>
                                                        <PlusIcon className="w-4 h-4 mr-2 group-hover:scale-110 transition-transform duration-200" />
                                                        Carregar Mais
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="text-center py-12">
                                    <ClockIcon className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                                    <h3 className="text-lg font-medium text-gray-900 mb-2">Nenhum histórico encontrado</h3>
                                    <p className="text-gray-500">Esta entidade ainda não possui histórico de alterações.</p>
                                </div>
                            )}
                        </div>

                        {/* Footer do Modal */}
                        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end">
                            <button
                                onClick={closeHistoricoModal}
                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Localização */}
            {isLocalizacaoModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="flex max-h-[90vh] w-full max-w-md flex-col overflow-hidden rounded-2xl bg-white shadow-2xl">
                        {/* Header do Modal */}
                        <div className="shrink-0 border-b border-gray-200 px-6 py-4">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="p-2 rounded-xl bg-blue-100 mr-3">
                                        <MapPinIcon className="w-5 h-5 text-blue-600" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900">
                                            {selectedLocalizacao ? 'Editar Localização' : 'Nova Localização'}
                                        </h3>
                                        <p className="text-sm text-gray-500">
                                            {selectedLocalizacao ? 'Atualize as informações da localização' : 'Adicione uma nova localização'}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => {
                                        setIsLocalizacaoModalOpen(false)
                                        setSelectedLocalizacao(null)
                                        setLocalizacaoForm({ nome: '', numero: '', complemento: '', cep: '' })
                                    }}
                                    className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-5 h-5 text-gray-500" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Modal */}
                        <div className="min-h-0 flex-1 overflow-y-auto px-6 py-6">
                            <form onSubmit={handleSaveLocalizacao} className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Nome da Localização *
                                    </label>
                                    <input
                                        type="text"
                                        value={localizacaoForm.nome}
                                        onChange={(e) => setLocalizacaoForm(prev => ({ ...prev, nome: e.target.value }))}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                                        placeholder="Ex: Matriz, Filial Centro..."
                                        required
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Número
                                    </label>
                                    <input
                                        type="text"
                                        value={localizacaoForm.numero}
                                        onChange={(e) => setLocalizacaoForm(prev => ({ ...prev, numero: e.target.value }))}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                                        placeholder="Ex: 123"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Complemento
                                    </label>
                                    <input
                                        type="text"
                                        value={localizacaoForm.complemento}
                                        onChange={(e) => setLocalizacaoForm(prev => ({ ...prev, complemento: e.target.value }))}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                                        placeholder="Ex: Sala 101, Andar 2..."
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        CEP *
                                    </label>
                                    <input
                                        type="text"
                                        value={formatCEP(localizacaoForm.cep)}
                                        onChange={(e) => {
                                            const unformatted = e.target.value.replace(/\D/g, '')
                                            setLocalizacaoForm(prev => ({ ...prev, cep: unformatted }))
                                        }}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                                        placeholder="00000-000"
                                        maxLength={9}
                                    />
                                </div>

                                {/* Botões */}
                                <div className="flex justify-end space-x-3 pt-4">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setIsLocalizacaoModalOpen(false)
                                            setSelectedLocalizacao(null)
                                            setLocalizacaoForm({ nome: '', numero: '', complemento: '', cep: '' })
                                        }}
                                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="submit"
                                        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                                    >
                                        {selectedLocalizacao ? 'Atualizar' : 'Salvar'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Departamento */}
            {isDepartamentoModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="flex max-h-[90vh] w-full max-w-md flex-col overflow-hidden rounded-2xl bg-white shadow-2xl">
                        {/* Header do Modal */}
                        <div className="shrink-0 border-b border-gray-200 px-6 py-4">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="p-2 rounded-xl bg-gray-100 mr-3">
                                        <BuildingOfficeIcon className="w-5 h-5 text-gray-600" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900">
                                            {selectedDepartamento ? 'Editar Departamento' : 'Novo Departamento'}
                                        </h3>
                                        <p className="text-sm text-gray-500">
                                            {selectedDepartamento ? 'Atualize as informações do departamento' : 'Adicione um novo departamento'}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => {
                                        setIsDepartamentoModalOpen(false)
                                        setSelectedDepartamento(null)
                                        setDepartamentoForm({ nome: '', localizacao_id: '' })
                                    }}
                                    className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-5 h-5 text-gray-500" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Modal */}
                        <div className="min-h-0 flex-1 overflow-y-auto px-6 py-6">
                            <form onSubmit={handleSaveDepartamento} className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Nome do Departamento *
                                    </label>
                                    <input
                                        type="text"
                                        value={departamentoForm.nome}
                                        onChange={(e) => setDepartamentoForm(prev => ({ ...prev, nome: e.target.value }))}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                                        placeholder="Ex: Financeiro, TI, RH..."
                                        required
                                    />
                                </div>

                                {/* Botões */}
                                <div className="flex justify-end space-x-3 pt-4">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setIsDepartamentoModalOpen(false)
                                            setSelectedDepartamento(null)
                                            setDepartamentoForm({ nome: '', localizacao_id: '' })
                                        }}
                                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="submit"
                                        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                                    >
                                        {selectedDepartamento ? 'Atualizar' : 'Salvar'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Histórico de Localização */}
            {isLocalizacaoHistoricoOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
                        {/* Header do Modal */}
                        <div className="px-6 py-4 border-b border-gray-200">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="p-2 rounded-xl bg-blue-100 mr-3">
                                        <ClockIcon className="w-5 h-5 text-blue-600" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900">
                                            Histórico da Localização
                                        </h3>
                                        <p className="text-sm text-gray-500">
                                            Visualize todas as alterações realizadas nesta localização
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={closeLocalizacaoHistoricoModal}
                                    className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-5 h-5 text-gray-500" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Histórico */}
                        <div className="px-6 py-6 max-h-[70vh] overflow-y-auto">
                            {states.localizacaoHistorico && states.localizacaoHistorico.length > 0 ? (
                                <div className="space-y-4">
                                    {states.localizacaoHistorico.map((item, index) => (
                                        <div key={item.id} className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                                            {/* Header do Item */}
                                            <div className="flex items-center justify-between mb-3">
                                                <div className="flex items-center">
                                                    <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${item.transformacao === 'Criação' ? 'bg-green-100' :
                                                        item.transformacao === 'Atualização' ? 'bg-blue-100' :
                                                            'bg-gray-100'
                                                        }`}>
                                                        {item.transformacao === 'Criação' ? (
                                                            <PlusIcon className="w-4 h-4 text-green-600" />
                                                        ) : item.transformacao === 'Atualização' ? (
                                                            <PencilIcon className="w-4 h-4 text-blue-600" />
                                                        ) : (
                                                            <TrashIcon className="w-4 h-4 text-gray-600" />
                                                        )}
                                                    </div>
                                                    <div>
                                                        <h4 className="text-sm font-semibold text-gray-900">
                                                            {item.transformacao}
                                                        </h4>
                                                        <p className="text-xs text-gray-500">
                                                            por {item.user_email} • {new Date(item.data_atualizacao).toLocaleString('pt-BR')}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Dados Atuais */}
                                            {item.dado_atual && (
                                                <div className="mb-3">
                                                    <h5 className="text-xs font-medium text-gray-700 mb-2">Dados Atuais:</h5>
                                                    <div className="bg-white rounded-lg p-3 space-y-1">
                                                        <p className="text-xs text-gray-600"><span className="font-medium">Nome:</span> {item.dado_atual.nome}</p>
                                                        {item.dado_atual.numero && <p className="text-xs text-gray-600"><span className="font-medium">Número:</span> {item.dado_atual.numero}</p>}
                                                        {item.dado_atual.complemento && <p className="text-xs text-gray-600"><span className="font-medium">Complemento:</span> {item.dado_atual.complemento}</p>}
                                                        {item.dado_atual.cep && <p className="text-xs text-gray-600"><span className="font-medium">CEP:</span> {formatCEP(item.dado_atual.cep)}</p>}
                                                        {item.dado_atual.logradouro && <p className="text-xs text-gray-600"><span className="font-medium">Logradouro:</span> {item.dado_atual.logradouro}</p>}
                                                        {item.dado_atual.bairro && <p className="text-xs text-gray-600"><span className="font-medium">Bairro:</span> {item.dado_atual.bairro}</p>}
                                                        {item.dado_atual.cidade && <p className="text-xs text-gray-600"><span className="font-medium">Cidade:</span> {item.dado_atual.cidade}</p>}
                                                        {item.dado_atual.estado && <p className="text-xs text-gray-600"><span className="font-medium">Estado:</span> {item.dado_atual.estado}</p>}
                                                    </div>
                                                </div>
                                            )}

                                            {/* Dados Anteriores */}
                                            {item.dado_antigo && (
                                                <div>
                                                    <h5 className="text-xs font-medium text-gray-700 mb-2">Dados Anteriores:</h5>
                                                    <div className="bg-red-50 rounded-lg p-3 space-y-1">
                                                        <p className="text-xs text-gray-600"><span className="font-medium">Nome:</span> {item.dado_antigo.nome}</p>
                                                        {item.dado_antigo.numero && <p className="text-xs text-gray-600"><span className="font-medium">Número:</span> {item.dado_antigo.numero}</p>}
                                                        {item.dado_antigo.complemento && <p className="text-xs text-gray-600"><span className="font-medium">Complemento:</span> {item.dado_antigo.complemento}</p>}
                                                        {item.dado_antigo.cep && <p className="text-xs text-gray-600"><span className="font-medium">CEP:</span> {formatCEP(item.dado_antigo.cep)}</p>}
                                                        {item.dado_antigo.logradouro && <p className="text-xs text-gray-600"><span className="font-medium">Logradouro:</span> {item.dado_antigo.logradouro}</p>}
                                                        {item.dado_antigo.bairro && <p className="text-xs text-gray-600"><span className="font-medium">Bairro:</span> {item.dado_antigo.bairro}</p>}
                                                        {item.dado_antigo.cidade && <p className="text-xs text-gray-600"><span className="font-medium">Cidade:</span> {item.dado_antigo.cidade}</p>}
                                                        {item.dado_antigo.estado && <p className="text-xs text-gray-600"><span className="font-medium">Estado:</span> {item.dado_antigo.estado}</p>}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}

                                    {/* Botão Carregar Mais Histórico de Localização */}
                                    {localizacaoHistoricoHasMore && (
                                        <div className="flex justify-center mt-6">
                                            <button
                                                onClick={loadMoreLocalizacaoHistorico}
                                                disabled={localizacaoHistoricoLoading}
                                                className="group relative inline-flex items-center px-6 py-3 border border-transparent rounded-xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-blue-600 via-blue-700 to-blue-700 hover:from-blue-700 hover:via-blue-800 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                {localizacaoHistoricoLoading ? (
                                                    <>
                                                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                                        Carregando...
                                                    </>
                                                ) : (
                                                    <>
                                                        <PlusIcon className="w-4 h-4 mr-2 group-hover:scale-110 transition-transform duration-200" />
                                                        Carregar Mais
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="text-center py-12">
                                    <ClockIcon className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                                    <h3 className="text-lg font-medium text-gray-900 mb-2">Nenhum histórico encontrado</h3>
                                    <p className="text-gray-500">Esta localização ainda não possui histórico de alterações.</p>
                                </div>
                            )}
                        </div>

                        {/* Footer do Modal */}
                        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end">
                            <button
                                onClick={closeLocalizacaoHistoricoModal}
                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Histórico de Departamento */}
            {isDepartamentoHistoricoOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
                        {/* Header do Modal */}
                        <div className="px-6 py-4 border-b border-gray-200">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="p-2 rounded-xl bg-gray-100 mr-3">
                                        <ClockIcon className="w-5 h-5 text-gray-600" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900">
                                            Histórico do Departamento
                                        </h3>
                                        <p className="text-sm text-gray-500">
                                            Visualize todas as alterações realizadas neste departamento
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={closeDepartamentoHistoricoModal}
                                    className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-5 h-5 text-gray-500" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Histórico */}
                        <div className="px-6 py-6 max-h-[70vh] overflow-y-auto">
                            {states.departamentoHistorico && states.departamentoHistorico.length > 0 ? (
                                <div className="space-y-4">
                                    {states.departamentoHistorico.map((item, index) => (
                                        <div key={item.id} className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                                            {/* Header do Item */}
                                            <div className="flex items-center justify-between mb-3">
                                                <div className="flex items-center">
                                                    <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${item.transformacao === 'Criação' ? 'bg-green-100' :
                                                        item.transformacao === 'Atualização' ? 'bg-blue-100' :
                                                            'bg-gray-100'
                                                        }`}>
                                                        {item.transformacao === 'Criação' ? (
                                                            <PlusIcon className="w-4 h-4 text-green-600" />
                                                        ) : item.transformacao === 'Atualização' ? (
                                                            <PencilIcon className="w-4 h-4 text-blue-600" />
                                                        ) : (
                                                            <TrashIcon className="w-4 h-4 text-gray-600" />
                                                        )}
                                                    </div>
                                                    <div>
                                                        <h4 className="text-sm font-semibold text-gray-900">
                                                            {item.transformacao}
                                                        </h4>
                                                        <p className="text-xs text-gray-500">
                                                            por {item.user_email} • {new Date(item.data_atualizacao).toLocaleString('pt-BR')}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Dados Atuais */}
                                            {item.dado_atual && (
                                                <div className="mb-3">
                                                    <h5 className="text-xs font-medium text-gray-700 mb-2">Dados Atuais:</h5>
                                                    <div className="bg-white rounded-lg p-3 space-y-1">
                                                        <p className="text-xs text-gray-600"><span className="font-medium">Nome:</span> {item.dado_atual.nome}</p>
                                                        <p className="text-xs text-gray-600"><span className="font-medium">Localização ID:</span> {item.dado_atual.localizacao_id}</p>
                                                        <p className="text-xs text-gray-600"><span className="font-medium">Criado em:</span> {new Date(item.dado_atual.data_criacao).toLocaleString('pt-BR')}</p>
                                                        <p className="text-xs text-gray-600"><span className="font-medium">Atualizado em:</span> {new Date(item.dado_atual.data_atualizacao).toLocaleString('pt-BR')}</p>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Dados Anteriores */}
                                            {item.dado_antigo && (
                                                <div>
                                                    <h5 className="text-xs font-medium text-gray-700 mb-2">Dados Anteriores:</h5>
                                                    <div className="bg-red-50 rounded-lg p-3 space-y-1">
                                                        <p className="text-xs text-gray-600"><span className="font-medium">Nome:</span> {item.dado_antigo.nome}</p>
                                                        <p className="text-xs text-gray-600"><span className="font-medium">Localização ID:</span> {item.dado_antigo.localizacao_id}</p>
                                                        <p className="text-xs text-gray-600"><span className="font-medium">Criado em:</span> {new Date(item.dado_antigo.data_criacao).toLocaleString('pt-BR')}</p>
                                                        <p className="text-xs text-gray-600"><span className="font-medium">Atualizado em:</span> {new Date(item.dado_antigo.data_atualizacao).toLocaleString('pt-BR')}</p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}

                                    {/* Botão Carregar Mais Histórico de Departamento */}
                                    {departamentoHistoricoHasMore && (
                                        <div className="flex justify-center mt-6">
                                            <button
                                                onClick={loadMoreDepartamentoHistorico}
                                                disabled={departamentoHistoricoLoading}
                                                className="group relative inline-flex items-center px-6 py-3 border border-transparent rounded-xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-blue-600 via-blue-700 to-blue-700 hover:from-blue-700 hover:via-blue-800 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                {departamentoHistoricoLoading ? (
                                                    <>
                                                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                                        Carregando...
                                                    </>
                                                ) : (
                                                    <>
                                                        <PlusIcon className="w-4 h-4 mr-2 group-hover:scale-110 transition-transform duration-200" />
                                                        Carregar Mais
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="text-center py-12">
                                    <ClockIcon className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                                    <h3 className="text-lg font-medium text-gray-900 mb-2">Nenhum histórico encontrado</h3>
                                    <p className="text-gray-500">Este departamento ainda não possui histórico de alterações.</p>
                                </div>
                            )}
                        </div>

                        {/* Footer do Modal */}
                        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end">
                            <button
                                onClick={closeDepartamentoHistoricoModal}
                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Confirmação de Exclusão de Localização */}
            {isDeleteLocalizacaoModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
                    <div className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full">
                        {/* Header do Modal */}
                        <div className="relative bg-gradient-to-r from-red-600 via-red-700 to-red-700 rounded-t-3xl p-6">
                            <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 to-red-500/10 rounded-t-3xl"></div>
                            <div className="relative flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="p-3 rounded-2xl bg-white/20 backdrop-blur-sm mr-4">
                                        <TrashIcon className="w-8 h-8 text-white" />
                                    </div>
                                    <div>
                                        <h2 className="text-2xl font-bold text-white">
                                            Confirmar Exclusão
                                        </h2>
                                        <p className="text-red-100 mt-1">
                                            Esta ação não pode ser desfeita
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={closeDeleteLocalizacaoModal}
                                    className="p-2 rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Modal */}
                        <div className="p-6">
                            <div className="text-center">
                                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                                    <TrashIcon className="h-6 w-6 text-red-600" />
                                </div>
                                <h3 className="text-lg font-medium text-gray-900 mb-2">
                                    Tem certeza que deseja excluir esta localização?
                                </h3>
                                <p className="text-sm text-gray-500 mb-4">
                                    A localização <strong>{localizacaoToDelete?.nome}</strong> será permanentemente removida do sistema.
                                </p>
                                <p className="text-xs text-red-600 font-medium">
                                    Esta ação não pode ser desfeita.
                                </p>
                            </div>
                        </div>

                        {/* Footer do Modal */}
                        <div className="flex items-center justify-end space-x-4 p-6 border-t border-gray-200">
                            <button
                                onClick={closeDeleteLocalizacaoModal}
                                className="px-6 py-3 border border-gray-300 rounded-2xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-300"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleConfirmDeleteLocalizacao}
                                disabled={isSubmitting}
                                className="group relative inline-flex items-center px-6 py-3 border border-transparent rounded-2xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-red-600 via-red-700 to-red-700 hover:from-red-700 hover:via-red-800 hover:to-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <div className="relative z-10 flex items-center">
                                    {isSubmitting ? (
                                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                    ) : (
                                        <TrashIcon className="w-4 h-4 mr-2" />
                                    )}
                                    <span>{isSubmitting ? 'Excluindo...' : 'Excluir'}</span>
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 to-red-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Confirmação de Exclusão de Departamento */}
            {isDeleteDepartamentoModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
                    <div className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full">
                        {/* Header do Modal */}
                        <div className="relative bg-gradient-to-r from-red-600 via-red-700 to-red-700 rounded-t-3xl p-6">
                            <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 to-red-500/10 rounded-t-3xl"></div>
                            <div className="relative flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="p-3 rounded-2xl bg-white/20 backdrop-blur-sm mr-4">
                                        <TrashIcon className="w-8 h-8 text-white" />
                                    </div>
                                    <div>
                                        <h2 className="text-2xl font-bold text-white">
                                            Confirmar Exclusão
                                        </h2>
                                        <p className="text-red-100 mt-1">
                                            Esta ação não pode ser desfeita
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={closeDeleteDepartamentoModal}
                                    className="p-2 rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Modal */}
                        <div className="p-6">
                            <div className="text-center">
                                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                                    <TrashIcon className="h-6 w-6 text-red-600" />
                                </div>
                                <h3 className="text-lg font-medium text-gray-900 mb-2">
                                    Tem certeza que deseja excluir este departamento?
                                </h3>
                                <p className="text-sm text-gray-500 mb-4">
                                    O departamento <strong>{departamentoToDelete?.nome}</strong> será permanentemente removido do sistema.
                                </p>
                                <p className="text-xs text-red-600 font-medium">
                                    Esta ação não pode ser desfeita.
                                </p>
                            </div>
                        </div>

                        {/* Footer do Modal */}
                        <div className="flex items-center justify-end space-x-4 p-6 border-t border-gray-200">
                            <button
                                onClick={closeDeleteDepartamentoModal}
                                className="px-6 py-3 border border-gray-300 rounded-2xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-300"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleConfirmDeleteDepartamento}
                                disabled={isSubmitting}
                                className="group relative inline-flex items-center px-6 py-3 border border-transparent rounded-2xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-red-600 via-red-700 to-red-700 hover:from-red-700 hover:via-red-800 hover:to-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <div className="relative z-10 flex items-center">
                                    {isSubmitting ? (
                                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                    ) : (
                                        <TrashIcon className="w-4 h-4 mr-2" />
                                    )}
                                    <span>{isSubmitting ? 'Excluindo...' : 'Excluir'}</span>
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 to-red-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Proprietario
